import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../components/layout";
import { SEO } from "../components/common";
import { templates } from "../data/templates";
import {
  CategoryFilter,
  TemplateCategory,
  TemplateCard,
} from "../components/templates";

export function TemplatesPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState<TemplateCategory>("all");

  const filteredTemplates = templates.filter(
    (template) =>
      activeCategory === "all" || template.category === activeCategory
  );

  return (
    <Layout>
      <SEO
        title="Block Templates | Ready-to-Use Patterns"
        description="Browse our collection of professional WordPress block templates. Find and customize pre-built patterns for headers, hero sections, pricing tables, and more."
        keywords={[
          "wordpress templates",
          "block patterns",
          "gutenberg templates",
          "wordpress layouts",
          "page templates",
        ]}
      />
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-white mb-8">Block Templates</h1>

        <CategoryFilter
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {filteredTemplates.map((template) => (
            <TemplateCard
              key={template.id}
              template={template}
              onClick={() => navigate(`/templates/${template.id}`)}
            />
          ))}
        </div>

        {filteredTemplates.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-400">
              No templates found in this category. Please try another category.
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
}
